module.exports = __webpack_public_path__ + "static/img/analog_logo.26db4a79.png";